import _classCallCheck from "/home/runner/work/Antt-Robotics-Website-React/Antt-Robotics-Website-React/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/Antt-Robotics-Website-React/Antt-Robotics-Website-React/node_modules/@babel/runtime/helpers/esm/createClass";
import { deepExtend } from "../../Utils/Utils";
export var ManualParticle = /*#__PURE__*/function () {
  function ManualParticle() {
    _classCallCheck(this, ManualParticle);
  }
  _createClass(ManualParticle, [{
    key: "load",
    value: function load(data) {
      var _a, _b;
      if (!data) {
        return;
      }
      if (data.position !== undefined) {
        this.position = {
          x: (_a = data.position.x) !== null && _a !== void 0 ? _a : 50,
          y: (_b = data.position.y) !== null && _b !== void 0 ? _b : 50
        };
      }
      if (data.options !== undefined) {
        this.options = deepExtend({}, data.options);
      }
    }
  }]);
  return ManualParticle;
}();